import { useEffect, useRef } from "react"
import { Button, Flex, Spin } from "antd"
import { Text } from "~/components/Text"
import styles from "./index.css"

type LoadMoreProps = {
  count: number
  hasMore: boolean
  loading: boolean
  error: string
  onLoad: () => void
  onRetry: () => void
  onReload: () => void
}

export const LoadMore = ({
  count,
  hasMore,
  loading,
  error,
  onLoad,
  onRetry,
  onReload,
}: LoadMoreProps) => {
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (
      !hasMore ||
      loading ||
      error ||
      !ref.current ||
      !window.IntersectionObserver
    )
      return
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) onLoad()
      },
      { rootMargin: "200px 0px" },
    )
    observer.observe(ref.current)
    return () => observer.disconnect()
  }, [count, hasMore, loading, error, onLoad])

  return (
    <Flex
      ref={ref}
      className={styles.loadMore}
      align="center"
      justify="center"
      gap={12}
      role={error ? "alert" : "status"}
      wrap
    >
      {loading ? (
        <Spin description="加载更多模板中…" />
      ) : error ? (
        <>
          <Text type="danger">{error}</Text>
          <Button onClick={onRetry}>重试加载</Button>
          <Button
            type="text"
            onClick={onReload}
          >
            重新加载列表
          </Button>
        </>
      ) : hasMore ? (
        <Button onClick={onLoad}>加载更多</Button>
      ) : count ? (
        <Text type="secondary">已加载全部模板</Text>
      ) : null}
    </Flex>
  )
}
